import { ShieldCheck, BadgeCheck, Zap } from "lucide-react";

const badges = [
  { Icon: ShieldCheck, label: "Transaksi Aman" },
  { Icon: BadgeCheck, label: "Platform Resmi" },
  { Icon: Zap, label: "Akses Instan" },
];

export const TrustBadges = () => (
  <div className="flex items-center gap-x-5 gap-y-2 flex-wrap" data-testid="trust-badges">
    {badges.map(({ Icon, label }) => (
      <span key={label} className="inline-flex items-center gap-1.5 font-mono text-[9px] uppercase tracking-[0.18em] text-[#211B10]/60">
        <Icon className="w-3.5 h-3.5 text-[#A67C1E]" />
        {label}
      </span>
    ))}
  </div>
);
